const resetIframeVideo = (iframe) => {
    const temp = iframe.src;
    iframe.src = '';
    setTimeout(() => {
        iframe.src = temp;
    }, 40);
};

const setIframeHeight = (iframe, width) => {
    iframe.style.height = (width / 16) * 9 + 'px';
};

const createIframeElement = (container, src) => {
    const iframe = document.createElement('iframe');

    iframe.src = src;
    iframe.style.width = '100%';

    setIframeHeight(iframe, container.offsetWidth);

    window.addEventListener('resize', () => {
        setIframeHeight(iframe, container.offsetWidth);
    });

    container.appendChild(iframe);
};

const initModalIframe = function (container) {
    const modalId = container.getAttribute('data-modal-iframe');
    const src = container.getAttribute('data-modal-iframe-src');

    const modal = document.getElementById(modalId);

    // Listening to event fired from toggle-class.js, as this script opens/closes the modal
    window.addEventListener('class-toggled', (e) => {
        if (e.detail.target == modal) {
            if (modal.classList.contains('hidden')) {
                resetIframeVideo(container.querySelector('iframe'));
            } else {
                if (container.querySelector('iframe')) {
                    return;
                }

                createIframeElement(container, src);
            }
        }
    });
};

const initModalIframes = function (containerAttribute = 'data-modal-iframe') {
    const containers = Array.from(document.querySelectorAll(`[${containerAttribute}]`));

    containers.forEach((container) => {
        initModalIframe(container);
    });
};

export { initModalIframes as default };
